import { request } from "../../services/requests";

export interface OverviewCounts {
  generated_at: string;
  /** null when the caller can't see Sales */
  orders_attention: number | null;
  payouts_pending: { count: number; totals: { currency: string; amount: number }[] } | null;
  applications_pending: number | null;
  chats_new_24h: number | null;
  services: { total: number; issues: number } | null;
  /** Promotion drafts (superadmins only) */
  promotions_drafts?: number | null;
}

export const getOverviewCounts = (token: string) => request(token).get<OverviewCounts>("overview/counts");

export interface SearchResults {
  q: string;
  orders: { order_id: string; created_at: string; total: number; currency: string; buyer: string | null; items: number }[] | null;
  users: { user_id: string; username: string | null; email: string; is_seller: boolean; country: string | null }[] | null;
  payouts: { withdrawal_id: string; username: string | null; amount: number; currency: string; status: string; request_date: string }[] | null;
}

export const searchAdmin = (token: string, q: string) => request(token).get<SearchResults>("search", { params: { q } });
